import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------

import { representanteService } from "../../../services/representanteService";

export const useRepresentante = (usuarioId: number) => {
  const [representante, setRepresentante] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as assinaturas
  useEffect(() => {
    const fetchRepresentante = async () => {
      if (usuarioId) {
        const data = await representanteService(usuarioId);
        setRepresentante(data);
      }
      setIsLoading(false);
    };

    fetchRepresentante();
  }, [usuarioId]);

  return { representante, isLoading };
};
